import * as React from 'react';

import { translate } from '~l10n/client';

import { AlertMessage } from '~shared/components/AlertMessage';
import { useWorkspaceQuizLock } from '~teacher/hook/workspaces/useWorkspaceQuizLock';

import { LockStatus, WorkspaceQuizLock } from '../../../api/workspaces/lock';

const messageStatusMap = new Map<LockStatus, string>([
  [
    LockStatus.LockedBySomeone,
    translate(
      'Another user must save and exit this quiz before you can edit it.'
    ),
  ],
  [
    LockStatus.LockedByYou,
    translate('No one can edit this quiz until you save and exit.'),
  ],
]);

interface Props {
  workspaceQuizId: string;
  workspaceId: string;
}

export function WorkspaceQuizLockBanner({
  workspaceId,
  workspaceQuizId,
}: Props) {
  const workspaceLockQuery = useWorkspaceQuizLock({
    workspaceId: workspaceId,
    workspaceQuizId: workspaceQuizId,
  });

  if (workspaceLockQuery.isSuccess) {
    const { lockStatus } = workspaceLockQuery.data;
    return <WorkspaceQuizLockSuccess lockStatus={lockStatus} />;
  }
  return <></>; // Loading, display nothing
}

type WorkspaceQuizLockProps = Pick<WorkspaceQuizLock, 'lockStatus'>;

function WorkspaceQuizLockSuccess({ lockStatus }: WorkspaceQuizLockProps) {
  if (messageStatusMap.get(lockStatus)) {
    return (
      <div className="py-4">
        <AlertMessage tone="info" align="center" showIcon>
          {messageStatusMap.get(lockStatus)}
        </AlertMessage>
      </div>
    );
  } else {
    return <></>;
  }
}
